import { Link } from 'react-router-dom';
import { fetchCardCatalog, fetchTerritoryCatalog } from '../api/client';
import { useAsync } from '../api/useCatalog';
import { BrandMark } from '../components/BrandMark';
import { BookIcon, DeckIcon, MapIcon } from '../components/Icons';

/** Mostra uma contagem ao vivo, ou um traço enquanto carrega/se falhar. */
function Stat({ value, label }: { value: number | null; label: string }): React.JSX.Element {
  return (
    <div className="home-card" style={{ textAlign: 'center' }}>
      <div className="stat-value">{value ?? '—'}</div>
      <p>{label}</p>
    </div>
  );
}

export function HomePage(): React.JSX.Element {
  const cards = useAsync(fetchCardCatalog);
  const territories = useAsync(fetchTerritoryCatalog);

  const cardCount = cards.data?.cards.length ?? null;
  const unitCount = cards.data?.cards.filter((c) => c.type === 'unit').length ?? null;
  const territoryCount = territories.data?.rules.length ?? null;

  return (
    <>
      <section className="hero">
        <BrandMark subtitle="Batalha de Territórios" />
        <div className="hero-play">
          <a className="btn btn-play" href="https://play.gameofbrasil.com">
            Jogar
          </a>
        </div>
        <div className="hero-actions">
          <Link className="btn btn-primary" to="/como-jogar">
            Como jogar
          </Link>
          <Link className="btn" to="/cartas">
            Ver cartas
          </Link>
        </div>
      </section>

      <div className="home-cards">
        <Stat value={cardCount} label="cartas no total" />
        <Stat value={unitCount} label="unidades" />
        <Stat value={territoryCount} label="territórios" />
      </div>

      <div className="home-cards">
        <Link className="home-card" to="/como-jogar">
          <div className="ico" style={{ color: 'var(--accent)' }}>
            <BookIcon />
          </div>
          <h3>Como Jogar</h3>
          <p>Objetivo, fluxo da partida, energia, os tipos de carta e como vencer — passo a passo.</p>
        </Link>
        <Link className="home-card" to="/cartas">
          <div className="ico" style={{ color: 'var(--green)' }}>
            <DeckIcon />
          </div>
          <h3>Cartas</h3>
          <p>Explore unidades, feitiços e armadilhas. Filtre por tipo, facção ou busque pelo nome.</p>
        </Link>
        <Link className="home-card" to="/territorios">
          <div className="ico" style={{ color: 'var(--energy)' }}>
            <MapIcon />
          </div>
          <h3>Territórios</h3>
          <p>Conheça os territórios e as regras que cada um impõe ao campo de batalha.</p>
        </Link>
      </div>
    </>
  );
}
